import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken,removeToken } from '@/utils/auth'
import router from '../router/index';



// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1800000 // request timeout
})

// 重复请求时，取消前面的请求
// let pending = []; // 声明一个数组用于存储每个请求的取消函数和标识
// let cancelToken = axios.CancelToken;
// let removePending = (ever) => {
//   for(let p in pending){
//     if(pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
//       pending[p].f(); //执行取消操作
//       pending.splice(p, 1); //把这条记录从数组中移除
//     }
//   }
// }


// request interceptor
service.interceptors.request.use(
  config => {
    // 取消前面的请求
    // removePending(config);
    // config.cancelToken = new cancelToken((c)=>{
    //   pending.push({ u: config.url + '&' + config.method, f: c });
    // });

    // do something before request is sent
    if(!config.hashader){
      if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['Authorization'] = 'Bearer ' + getToken()
      } else {
        config.headers['Authorization'] = 'Basic ' + window.btoa(process.env.VUE_APP_CLIENT_ID + ':' + process.env.VUE_APP_CLIENT_SECRET)
      }
    }
    if (process.env.VUE_APP_ISOLATION_VERSION) {
      config.headers['z-l-t-version'] = process.env.VUE_APP_ISOLATION_VERSION
    }

    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // 取消前面的请求
    // removePending(response.config);

    // const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (response.status !== 200) {
      Message({
        message: response.data.resp_msg,
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response.data
    }
  },
  error => {
    if(error.response.status){
      if (error.response.status === 401) {
        // location.reload()
        Message({
          message: '请登录',
          type: 'info',
          duration: 5 * 1000
        })
        removeToken();
        store.commit('user/REMOVE_TOKEN');
        window.localStorage.clear();
        router.push({path:'/'})
      } else if(error.response.status === 400){
        Message({
          message: error.response.data.resp_msg,
          type: 'warning',
          duration: 5 * 1000
        })
        if (error.response.data.resp_msg == "用户名或密码错误") {
          store.commit("user/increment");
        }
      } else {
        Message({
          message: error.response.data.resp_msg,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(error.response.data.resp_msg)
      }
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js